import { RootState } from '@iwProvider/configureStore';
import _ from 'lodash';

import { getDrawdownAmountFromQueryParams } from './DrawDownHelper';
import { getDrawdownAmount as getOfferConfigurationDrawDownAmount } from './offerConfigurationSelectors';
import { getAllAccounts } from '../multiLoanDashboard/accountsSelector';

export const getDrawDownAmount = (state: RootState) => {
    const amountFromParams = getDrawdownAmountFromQueryParams();
    if (amountFromParams) {
        return parseInt(amountFromParams);
    }

    return (
        getOfferConfigurationDrawDownAmount(state) ||
        state?.api?.customer_state?.data?.ui?.draw_down?.amount
    );
};

export const getOutstandingBalanceOnCurrentDay = (state: RootState) => {
    const latestOngoingLoan = _.find(getAllAccounts(state), {
        loan_status: 'ongoing'
    });

    return latestOngoingLoan?.balance?.total ?? 0;
};
